import React, { FC } from "react";
import { Box, IconButton, makeStyles } from "@material-ui/core";
import { color, px } from "Configs/theme";
import EditIcon from "@material-ui/icons/Edit";

interface Props {
	width: number;
	isBottomBorderTransparent?: boolean;
	isEditable?: boolean;
	onClickEdit?: () => void;
}

const CalendarNameColumn: FC<Props> = (props) => {
	const classes = useStyles({
		width: props.width,
		isBottomBorderTransparent: props.isBottomBorderTransparent,
	});

	return (
		<Box className={classes.root}>
			{props.children && <Box className={classes.name}>{props.children}</Box>}
			{props.isEditable && (
				<IconButton size="small" onClick={props.onClickEdit}>
					<EditIcon fontSize="inherit" />
				</IconButton>
			)}
		</Box>
	);
};

export default CalendarNameColumn;

interface StyleProps {
	width: number;
	isBottomBorderTransparent?: boolean;
}

const useStyles = makeStyles({
	root: (props: StyleProps) => ({
		display: "flex",
		alignItems: "start",
		justifyContent: "space-between",
		whiteSpace: "nowrap",
		overflow: "hidden",
		fontSize: "14px",
		fontWeight: "bold",
		borderBottom: `1px solid ${
			props.isBottomBorderTransparent ? "transparent" : color.tableCellBorder
		}`,
		width: props.width - 1,
		"& > button": {
			marginTop: px.s,
			marginRight: px.s,
			display: "none",
		},
		"&:hover > button": {
			display: "block",
		},
	}),
	name: {
		paddingLeft: px.xl,
		paddingTop: 10,
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
		"& > div > svg": {
			fontSize: "12px",
			marginRight: px.s,
			transform: "translate(0, 1px)",
		},
	},
});
